import gql from 'graphql-tag';
import { ProductListOptions, SearchQueryVariables } from '~/generated/graphql';
import { QueryOptions, sdk } from '../../graphqlWrapper';

// --- SDK functions ---
export function search(variables: SearchQueryVariables, options: QueryOptions) {
  return sdk.search(variables, options);
}

export function searchFacetValues(
  variables: SearchQueryVariables,
  options: QueryOptions,
) {
  return sdk.searchFacetValues(variables, options);
}

export function getProductBySlug(slug: string, options: QueryOptions) {
  return sdk.product({ slug }, options);
}

export function getProductById(id: string, options: QueryOptions) {
  return sdk.product({ id }, options);
}

export function getAllProducts(options: ProductListOptions, request: Request) {
  return sdk
    .products({ options }, { request })
    .then((result) => result.products?.items);
}

// --- Fragments ---
export const detailedProductFragment = gql`
  fragment DetailedProduct on Product {
    id
    name
    slug
    description

    collections {
      id
      slug
      name
      breadcrumbs {
        id
        name
        slug
      }
    }

    facetValues {
      facet {
        id
        code
        name
      }
      id
      code
      name
    }

    featuredAsset {
      id
      preview
    }

    assets {
      id
      preview
    }

    variants {
      id
      name
      priceWithTax
      currencyCode
      sku
      stockLevel
      featuredAsset {
        id
        preview
      }
      customFields {
        priceTiers {
          minQty
          maxQty
          price
        }
        originalPrice
      }
    }
    customFields {
      shortDescription
    }
    supplier {
      id
      merchantId
      name
      status
    }
    supplier {
      id
      merchantId
      name
      status
    }
  }
`;

export const listedProductFragment = gql`
  fragment ListedProduct on SearchResult {
    productId
    productName
    description
    slug
    productAsset {
      id
      preview
    }
    productVariant {
      customFields {
        priceTiers {
          price
          minQty
          maxQty
        }
        originalPrice
      }
    }
    currencyCode
    priceWithTax {
      ... on PriceRange {
        min
        max
      }
      ... on SinglePrice {
        value
      }
    }
    productVariantId
    productVariantName
    sku
    inStock
    supplier {
      id
      merchantId
      name
      status
    }
    supplier {
      id
      merchantId
      name
      status
    }
  }
`;

// --- Queries ---
gql`
  query products($options: ProductListOptions) {
    products(options: $options) {
      items {
        ...DetailedProduct
      }
    }
  }
  ${detailedProductFragment}
`;

gql`
  query product($slug: String, $id: ID) {
    product(slug: $slug, id: $id) {
      ...DetailedProduct
    }
  }
  ${detailedProductFragment}
`;

gql`
  query search($input: SearchInput!) {
    search(input: $input) {
      totalItems
      items {
        ...ListedProduct
      }
      facetValues {
        count
        facetValue {
          id
          code
          name
          facet {
            id
            code
            name
          }
        }
      }
    }
  }
  ${listedProductFragment}
`;

gql`
  query searchFacetValues($input: SearchInput!) {
    search(input: $input) {
      totalItems
      facetValues {
        count
        facetValue {
          id
          code
          name
          facet {
            id
            code
            name
          }
        }
      }
    }
  }
  ${listedProductFragment}
`;
